t = require('app/scripts/views/internal/teacup-with-helpers')('sticker_select_item_upload')

module.exports = ->
  t.form { action: '/1/member/' + t.mustacheVar('id') + '/customStickers', method: 'post', enctype: 'multipart/form-data' }, ->
    t.input { type: 'hidden', name: 'token', value: '' }
    t.input { type: 'hidden', name: 'format', value: 'http' }
    t.div '.sticker-select.sticker-select-upload', ->
      t.span '.sticker-select-upload-icon.icon-lg.icon-add'
      t.input { type: 'file', name: 'file', class: 'sticker-select-upload-input js-upload-image ' + t.mustacheBlockInverted('enabled_customStickers', (-> ' disabled')), multiple: 'multiple', accept: 'image/*' }
